const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Thailand',
  code: 'TH',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'Subdistrict, District', width: 0.5 },
    stateCode: { label: 'Province', width: 0.5 },
    zipCode: { label: 'Postal Code', normalize: exports.zipCodeNormalize }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'stateCode'],
    ['zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 characters, 12345'
    }
  ]
};
